import React from 'react';
import { connect } from "react-redux";

import './App.css';
import Footer from './components/Footer/Footer';
import AppSuperBar from './components/AppSuperBar';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import LoginMat from './components/LoginMat/';
import ListReclamos from './components/Tramites/'
import TramitesMonitoreo from './components/TramitesMonitoreo/';
import TramitesConMovimientos from './components/TramitesConMovimientos'
import TramitesHistoria from './components/TramitesHistoria';
import LoginClaveUnica from './components/LoginClaveUnica/';
import PrivateRoute from './components/routers/PrivateRoute/';


function App() {
  return (
    <Router>
      <div className="App" style={{ 
      position: 'absolute', left: '0px', width: '100%', height: '100vh'
    }}>
        <AppSuperBar />
        <Switch>
          

        <Route exact path="/login" component={LoginMat} />
          <PrivateRoute  path="/listreclamo" component={ListReclamos}/>
          <PrivateRoute  path="/monitoreo" component={TramitesMonitoreo}/>
          <PrivateRoute  path="/movimientos" component={TramitesConMovimientos}/>
          <PrivateRoute  path="/historia" component={TramitesHistoria}/>
          <Route exact path="/claveunica" component={LoginClaveUnica} />
          <Route exact path="/validacion" component={LoginClaveUnica} />
          <Route  path="/" component={LoginMat} />
          
        </Switch>

        <Footer />
      </div>
    </Router>
  );
}


const mapStatetoProps = state => {
  return {
    user: state.user
  };
};


export default connect(mapStatetoProps)(App);